module.exports = __webpack_public_path__ + "static/media/linkedin-logo.5b238434.svg";